"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeState = exports.encodeState = exports.STATE_DELIMITER = void 0;
exports.STATE_DELIMITER = '#';
const encodeState = (...values) => {
    return btoa(values.filter(v => v).join('#'));
};
exports.encodeState = encodeState;
const decodeState = (state) => {
    return atob(state).split(exports.STATE_DELIMITER);
};
exports.decodeState = decodeState;
